import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { constants } from 'src/app/shared/constants';
import { Asset, Case } from 'src/app/shared/model/itsm';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';
import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';

@Component({
  selector: 'app-assetview',
  templateUrl: './assetview.component.html',
  styleUrls: ['./assetview.component.scss']
})
export class AssetViewComponent implements OnInit {
  // pagination
  perPage = constants.recordsPerPage.cases;
  currentPage: number;

  // date
  assetRef: string;
  asset: Asset;

  // case view
  viewType: string;
  page: string;
  cases: Case[];
  subsetCases: Case[];
  casesLoaded: boolean;
  entitlementsLoaded: boolean;

  sort: string;
  sortBy: string;
  originalName: string;

  // user prefs
  flags: any[];
  flagRefs: string[];
  flaggingRef: string //used to stop the flapping of flags whilst waiting for update to complete
  flagcount: number;

  constructor(
    private route: ActivatedRoute, 
    private userprefService: UserPreferenceService,
    private itsmService: ItsmService, 
    private errorService: ErrorService) { }

  ngOnInit(): void {
    this.casesLoaded = false;
    this.entitlementsLoaded = false;
    this.route.params.subscribe(params => this.assetRef = params['assetRef']);
    this.page = 'cases';
    this.currentPage = 1;
    
    this.refreshSupportUserPrefs()
      .then(() => {
        this.itsmService.getCachedAssets()
          .then(assets => {
            this.asset = assets.find(a => a.id == this.assetRef);

            if (this.asset) {
              this.originalName = this.asset.name;
              // add the model to the name (if we have it)
              if (this.asset.model && (this.asset.model !== this.asset.name)) {
                this.asset.name = this.asset.model + " | " + this.asset.name;
              }
            }

            // get the entitlements for the asset
            this.itsmService.getCachedServices().then(ents => {

              // replace the asset's partial entitlements will full entitlements
              this.asset.entitlements = this.asset.entitlements || [];
              this.asset.entitlements = this.asset.entitlements.map(ae => {
                return ents.find(ent => ent.id == ae.id);
              });

              // remove empty/null/missing entitlements
              this.asset.entitlements = this.asset.entitlements.filter(e => e);

              // sort the asset's entitlements by date order
              this.asset.entitlements = this.asset.entitlements.sort((e1, e2) => (e1.startDate > e2.startDate) ? 1 : -1);
            });


            this.cases = [];
            this.loadCases();
            let assetFlaggedCases = this.cases.filter(c => this.flagRefs.includes(c.id));
            this.flagcount = assetFlaggedCases.length;
            this.entitlementsLoaded = true;
          });


        // this.itsmService.getAsset(this.assetRef)
        // .then(res => {
        //   this.asset = res;
        //   this.cases = this.asset.cases;
        //   // check how many are flagged
        //   let assetFlaggedCases = this.cases.filter(c => this.flagRefs.includes(c.id));
        //   this.flagcount = assetFlaggedCases.length;
        //   this.casesLoaded = true;
        // })
        // .catch(err => {
        //   this.errorService.handlerError(err);
        // });
      });
  }

  loadCases(): Promise<void> {
    return new Promise((resolve,reject) => {
      let searchCriteria = new SupportCaseSearchCriteria();

      searchCriteria.asset = this.asset.serialNumber + "||" + this.originalName;
      if(this.sort) {
        searchCriteria.sort = this.sort;
      }
      if(this.sortBy) {
        searchCriteria.sortBy = this.sortBy;
      }

      this.itsmService.caseSearch(searchCriteria)
        .then(res => {
          this.cases = res;
          this.casesLoaded = true;
          this.subsetCases = this.cases.slice(0, this.perPage);
          resolve();
        })
        .catch(err => {
          reject();
          this.handlerError(err);
        });
    });
  }

  /** 
   * Filter flagged cases
   */
  loadFlagged(){
    this.cases = this.cases.filter(c => this.flagRefs.includes(c.id));
    this.page = 'flagged';
  }


  /**
   * Refresh the local flagRefs and viewType variable from user preferences
   */
  refreshSupportUserPrefs(): Promise<void>{
    // load the flagged signals from user preferences
    return new Promise((resolve,reject) => {
      this.userprefService.getUserPreferences()
        .then(res => {
          if(res.flags && res.flags.assets){
            this.flagRefs = res.flags.assets;
          }else{
            this.flagRefs = [];
          }
          if(res.supportViewType){
            this.viewType = res.supportViewType;
          }else{
            this.viewType = 'grid';
          }
          resolve();
        })
        .catch(err => reject(err));
    });
  }
  
   /**
   * Toggle between grid/list view
   * @param view 
   */
  changeViewType(view: string){
    // set local variable to determine what view the user is using
    this.viewType = view;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateSingle(constants.local.views.support, view)
      .then(res => {
        this.refreshSupportUserPrefs()
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  onPageChange($event){
    this.casesLoaded = false;
    this.subsetCases = this.cases.slice(this.perPage*(this.currentPage-1), this.perPage*(this.currentPage-1)+this.perPage);
    this.casesLoaded = true;
  }

  sortResults(field: string){
    this.casesLoaded = false;
    this.currentPage = 1;
    if(this.sort === field && this.sortBy){
      if(this.sortBy === 'DESC') {
        this.sortBy = 'ASC';
      }else{
        this.sortBy = 'DESC';
      }
    }else{
      this.sort = field;
      this.sortBy = 'DESC';
    }

    this.loadCases();
  }

  /**
   * Add a asset reference to the user's preferences so they can flag cases
   * @param assetRef 
   */
  flag(assetRef: string) {
    // note which ref is being processed so we can stop user double clicking
    this.flaggingRef = assetRef;

    // update the users flags appropriately
    this.userprefService.userPreferencesUpdateFlags(constants.local.flags.assets, assetRef, this.flagRefs.includes(assetRef))
      .then(res => {
        this.refreshSupportUserPrefs()
          .then(res => {
            this.flaggingRef = undefined;
          })
          .catch(err => { throw err });
      })
      .catch(err => {
        this.handlerError(err);
      })
  }

  /**
   * Error handling forwarder, only not going direct so 
   * it allows us to add context within this module
   * @param err 
   */
  private handlerError(err){
    this.errorService.handlerError(err);
  }
}
